/** Lấy Google Drive file id từ URL lh3 / drive */
export function extractGoogleDriveFileId(url) {
  if (!url) return null;
  const s = String(url).trim();
  const m =
    s.match(/googleusercontent\.com\/d\/([^/?&#]+)/i) ||
    s.match(/drive\.google\.com\/file\/d\/([^/]+)/i) ||
    s.match(/[?&]id=([^&]+)/);
  return m ? m[1] : null;
}

/**
 * URL googleusercontent ?authuser=0 thường không load được trong <img>.
 * Ưu tiên drive thumbnail / lh3 với suffix size.
 */
export function luxuryproImageUrl(url, size = 200) {
  if (!url) return '';
  const s = String(url).trim();
  if (!s.includes('googleusercontent') && !s.includes('drive.google')) {
    return s;
  }

  const id = extractGoogleDriveFileId(s);
  if (id) {
    return `https://drive.google.com/thumbnail?id=${encodeURIComponent(id)}&sz=w${size}`;
  }

  const base = s.split('?')[0].replace(/=s\d+(-c)?$/i, '').replace(/=w\d+(-h\d+)?$/i, '');
  return `${base}=s${size}`;
}

/** URL dự phòng khi thumbnail drive lỗi */
export function luxuryproImageUrlFallback(url, size = 200) {
  const id = extractGoogleDriveFileId(url);
  if (!id) return '';
  return `https://lh3.googleusercontent.com/d/${id}=s${size}`;
}
